export interface TransformationPath {
  id: string;
  base: string;
  frames: { a: number; b: number; h: number; k: number; pauseMs: number }[];
}

export const TRANSFORMATION_PRESETS: TransformationPath[] = [
  {
    id: 'sin-stretch',
    base: 'sin(x)',
    frames: [
      { a: 1, b: 1, h: 0, k: 0, pauseMs: 600 },
      { a: 2, b: 1, h: 0, k: 0, pauseMs: 600 },
      { a: 2, b: 2, h: 0, k: 0, pauseMs: 600 },
      { a: 2, b: 2, h: Math.PI / 4, k: 0, pauseMs: 600 },
      { a: 2, b: 2, h: Math.PI / 4, k: 1, pauseMs: 800 },
    ],
  },
];
